/**
 * The page's words (ADR-119 decision 2, "One function"): `say` bound to the page's catalogue, so a panel asks for a
 * key and never holds a sentence. English is the only language and is bundled, so it is both the active catalogue
 * and the fallback; a key and its parameters are checked against it at compile time.
 */

import { say as sayIn, type Params, type SayParams, type WordValueAt } from "daedalus-core/words";
import { EN, type EnKey } from "odyssey-lang";

/**
 * Words a key of the game's catalogue.
 *
 * @param key The key, a dotted path of the English catalogue.
 * @param params The value's parameters, exactly: one per placeholder, and `count` for a plural object. Omitted when
 *   the value takes none.
 * @returns The words.
 * @example
 * say("chat.nowAfk");
 * say("chat.afkWhisper", { name: "Mira Thornwood" });
 */
export function say<K extends EnKey, const P extends Params<WordValueAt<typeof EN, K>> = Params<WordValueAt<typeof EN, K>>>(key: K, ...params: SayParams<WordValueAt<typeof EN, K>, P>): string {
  return sayIn<typeof EN, K, P>(EN, EN, key, ...params);
}
